// extracted by mini-css-extract-plugin
module.exports = {"modalMask":"Modal_modalMask__1kANk","modalBody":"Modal_modalBody__2ss9D"};